import { openBlock as a, createElementBlock as e, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M21.288 1.634a.75.75 0 0 1 .578.578c.136.643-.078 1.41-.352 2.085-.291.717-.721 1.499-1.197 2.243a20.058 20.058 0 0 1-1.53 2.083c-.376.446-.762.853-1.12 1.16l.677 8.79a.75.75 0 0 1-.217.589l-2.122 2.121a.75.75 0 0 1-1.27-.407l-1.216-7.3L9.86 16.19v3.857a.75.75 0 0 1-.22.53L8.227 21.99a.75.75 0 0 1-1.266-.383l-.586-2.933h-.8a.75.75 0 0 1-.75-.75v-.799l-2.932-.587a.75.75 0 0 1-.383-1.265l1.414-1.415a.75.75 0 0 1 .53-.22h3.857l2.612-3.657-7.3-1.216a.75.75 0 0 1-.406-1.27l2.121-2.122a.75.75 0 0 1 .588-.217l8.792.676a10.43 10.43 0 0 1 1.159-1.12 20.072 20.072 0 0 1 2.083-1.529c.744-.476 1.526-.906 2.243-1.197.675-.274 1.442-.488 2.085-.352Zm-5.443 4.224c-.57.481-.974.898-1.166 1.178a.75.75 0 0 1-.676.322l-8.848-.68-.847.847 7.048 1.174a.75.75 0 0 1 .487 1.176l-3.536 4.95a.75.75 0 0 1-.61.314H3.765l-.204.203 2.162.433a.75.75 0 0 1 .603.735v.664h.664a.75.75 0 0 1 .735.603l.433 2.162.203-.204v-3.932a.75.75 0 0 1 .314-.61l4.95-3.536a.75.75 0 0 1 1.176.487l1.174 7.048.847-.847-.68-8.848a.75.75 0 0 1 .322-.676c.28-.192.697-.597 1.178-1.166.47-.557.968-1.23 1.412-1.924.445-.696.825-1.393 1.07-1.998.084-.208.146-.39.19-.548a5.395 5.395 0 0 0-.547.191c-.605.245-1.302.625-1.998 1.07a18.72 18.72 0 0 0-1.924 1.412Z",
  "clip-rule": "evenodd"
}, null, -1), o = [
  c
];
function n(r, d) {
  return a(), e("svg", t, [...o]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
